import { NewsComment } from "./types";

export const mockComments: NewsComment[] = [
  {
    id: "1",
    parent_id: null,
    user: {
      name: "Aiden Parker",
      role: "Marketing Chief",
      avatarUrl: "https://i.pravatar.cc/150?img=1"
    },
    text: "Interesting move. Trustpilot is quietly becoming one of the most influential infrastructure layers for online commerce — not by selling ads, but by owning trust. This new €10M round signals that investors clearly see reviews as core to conversion, not a \"nice to have\". With Index Ventures on board, expect Trustpilot to accelerate the shift from basic stars + text to deeper data signals — patterns, anomalies, authenticity scoring, sentiment intelligence.",
    timeAgo: "6 hours ago"
  },
  {
    id: "2",
    parent_id: "1",
    user: {
      name: "Aiden Parker",
      role: "Marketing Chief",
      avatarUrl: "https://i.pravatar.cc/150?img=1"
    },
    text: "Platforms that can prove authenticity at scale will have the leverage. And if Trustpilot uses this money to deepen verification tech (AI fraud detection, identity signals, repeat buyer patterns), they will basically become the \"credit score\" for online merchants.",
    timeAgo: "4 hours ago"
  },
  {
    id: "3",
    parent_id: null,
    user: {
      name: "Nora Hayes",
      role: "Lead of Innovation",
      avatarUrl: "https://i.pravatar.cc/150?img=5"
    },
    text: "In the next 2–3 years, the winners in e-commerce won't be the platforms with the loudest ads, but the ones with the most credible trust layer. This is one more step in that direction.",
    timeAgo: "8 hours ago"
  },
  {
    id: "4",
    parent_id: null,
    user: {
      name: "Ethan Brooks",
      role: "Head of Technology",
      avatarUrl: "https://i.pravatar.cc/150?img=12"
    },
    text: "Makes sense. This whole space is shifting from pure marketing to evidence-based decision making. If they execute well, Trustpilot can evolve from \"review site\" to a real trust infrastructure layer for global commerce — almost like a standard.",
    timeAgo: "12 hours ago"
  },
  {
    id: "5",
    parent_id: "4",
    user: {
      name: "Sarah Johnson",
      role: "Product Manager",
      avatarUrl: "https://i.pravatar.cc/150?img=9"
    },
    text: "Completely agree. The infrastructure approach is the right direction. It's about building trust at scale, not just collecting reviews.",
    timeAgo: "10 hours ago"
  },
  {
    id: "6",
    parent_id: "1",
    user: {
      name: "Michael Chen",
      role: "Data Analyst",
      avatarUrl: "https://i.pravatar.cc/150?img=20"
    },
    text: "The data signals aspect is particularly interesting. Moving beyond simple ratings to actual behavioral patterns could revolutionize how we assess trustworthiness.",
    timeAgo: "3 hours ago"
  }
];

/**
 * Simulates an API call to fetch comments with a 500ms delay
 * @returns Promise that resolves with mock comments after 500ms
 */
export const fetchComments = (): Promise<NewsComment[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockComments);
    }, 500);
  });
};

